import React from "react";
import { DynamicWidget } from "@dynamic-labs/sdk-react-core";

interface DynamicLoginButtonProps {
  text?: string;
}

const DynamicLoginButton: React.FC<DynamicLoginButtonProps> = ({
  text = "Log in or Sign up",
}) => (
  <DynamicWidget
    innerButtonComponent={
      <button
        style={{
          padding: "10px 24px",
          background: "linear-gradient(90deg, #2563eb 0%, #2E93FF 100%)",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "1rem",
          border: "none",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(46,147,255,0.10)",
          cursor: "pointer",
          transition: "box-shadow 0.2s, background 0.2s, filter 0.2s",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          position: "relative",
          overflow: "hidden",
          width: "100%",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.filter = "brightness(1.08)";
          e.currentTarget.style.boxShadow = "0 8px 32px rgba(46,147,255,0.18)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.filter = "none";
          e.currentTarget.style.boxShadow = "0 2px 8px rgba(46,147,255,0.10)";
        }}
      >
        {text}
      </button>
    }
  />
);

export default DynamicLoginButton;
